import React from 'react'
import Head from '../components/Head'
import Front from '../components/Front'
import Testimonial from '../components/Testimonial/Testimonial'
import About from '../components/AboutUs/About'
import Modals from '../components/ModalsForm/Modals'
import RoadMap from '../components/Footer/RoadMap'
import { ScrollingProvider, Section } from 'react-scroll-section'
import Article from '../components/Article/Article'
import Map from "../components/Footer/Map";
import Partner from "../components/partners/Partner";
import Custmers from '../components/partners/Custmers'
import QuestAnswer from "../components/Questions/QuestAnswer";
export default function Main() {
    return (
        <div>
            <ScrollingProvider>
                <Head />
                <Section id='home'>
                <Front />
                </Section>
                <Section id='about' >
                    <About />
                </Section>
                <Article/>
                <Section id='rdv'>
                </Section>
                <Testimonial />
                <Section id='contact_us'>
                   <Modals/>
                </Section>
                <QuestAnswer/>
                <Custmers/>
               <Map/>
               <RoadMap />
            </ScrollingProvider>
        </div>
    )
}
